module.exports = __webpack_public_path__ + "media/images/brand/logo-fusic-3b8d5afc7cf34aa2b28d3fec29ce2c0a.svg";